"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProvinceRequest = void 0;
var SearchProvinceRequest = /** @class */ (function () {
    function SearchProvinceRequest() {
    }
    return SearchProvinceRequest;
}());
exports.SearchProvinceRequest = SearchProvinceRequest;
;
//# sourceMappingURL=searchProvince.request.js.map